import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import FullIcon from '@panel/commons/assets/icons/full-icon.svg';
import PositiveIcon from '@panel/commons/assets/icons/positivo_hover.svg';
import WarmIcon from '@panel/commons/assets/icons/neutro_hover.svg';
import NegativeIcon from '@panel/commons/assets/icons/negativo_hover.svg';
import AlertIcon from '../../assets/icons/alertNotify.svg';
import NeutralIcon from '../../assets/icons/noQualityFace.svg';

const siteId = process.env.REACT_APP_BUILD_SITE;
const isBrazilPortal = siteId && siteId.includes('BR');

const Container = styled.div`
  width: 100%;
  height: fit-content;
`;

const HeaderArea = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  position: relative;
`;

const ContainerInfo = styled.div`
  position: ${({ device }) => (device !== 'mobile' ? 'absolute' : 'relative')};
  right: 0px;
  color: ${select('grayDarkLight')};
  display: flex;
  justify-content: center;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  margin-top: ${({ device }) => (device !== 'mobile' ? '0' : '20')}px;
  ${({ ratingsError }) =>
    ratingsError &&
    css`
      filter: blur(3px);
    `}
`;

const TitleText = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 600;
  font-size: ${({ fontSize }) => (!fontSize ? '16px' : fontSize)};
  line-height: 130%;
  height: 21px;
  margin-right: 9px;
  margin-bottom: ${({ mBottom }) => (!mBottom ? '0' : mBottom)};
`;

const TooltipComponent = styled.div`
  padding: 3px 8px;
  width: 280px;
  height: 25px;
  white-space: pre-wrap;
  text-align: center;
`;

const IconTooltip = styled.img`
  margin-top: 6px;
`;

const IconInfo = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 5px;
`;

const MainArea = styled.div`
  display: flex;
  flex-direction: ${({ device }) => (device !== 'mobile' ? 'row' : 'column')};
  justify-content: ${({ device }) => (device !== 'mobile' ? 'space-between' : 'center')};
  align-items: ${({ device }) => (device !== 'mobile' ? 'flex-start' : 'center')};
  gap: ${({ device }) => (device === 'desktop' ? '74.15px' : '54px')};
  ${({ notRespondedCount }) =>
    notRespondedCount &&
    css`
      margin-bottom: ${({ device }) => (device !== 'mobile' ? '0' : '38')}px;
    `};
  ${({ device }) =>
    device === 'tablet' &&
    css`
      margin-bottom: ${({ notRespondedCount }) => (notRespondedCount ? '20' : '35')}px;
    `};
`;

const LeftSide = styled.div`
  width: ${({ device }) => (device !== 'mobile' ? '67%' : '100%')};
  display: flex;
  gap: 8px;
  flex-direction: column;
  justify-content: ${({ device }) => (device !== 'mobile' ? 'flex-start' : 'center')};
  align-items: ${({ device }) => (device !== 'mobile' ? 'flex-start' : 'center')};
  .emptyState {
    font-size: 16px;
  }
`;

const ContainerModalBody = styled.div`
  display: flex;
  flex-direction: ${({ device }) => (device !== 'mobile' ? 'row' : 'column')};
  justify-content: ${({ device }) => (device !== 'mobile' ? 'space-between' : 'center')};
  align-items: ${({ device }) => (device !== 'mobile' ? 'flex-start' : 'center')};
  gap: ${({ device }) => (device === 'desktop' ? '74.15px' : '54px')};
  ${({ notRespondedCount }) =>
    notRespondedCount &&
    css`
      margin-bottom: ${({ device }) => (device !== 'mobile' ? '24' : '38')}px;
    `};
  ${({ device }) =>
    device === 'tablet' &&
    css`
      margin-bottom: ${({ notRespondedCount }) => (notRespondedCount ? '20' : '35')}px;
    `};
`;

const ContainerRaitings = styled.div`
  width: 95%;
  height: 67px;
  justify-content: space-between;
  gap: ${({ device }) => (device !== 'mobile' ? '16px' : '7px')};
  margin-bottom: 14px;
  margin-right: 24px;
`;

const ContainerValue = styled.div`
  width: 82px;
  height: 43.785px;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 106%;
  display: flex;
  align-items: flex-end;
  margin-top: 5px;
`;

const Rating = styled.div`
  width: 80px;
  display: flex;
  gap: 6px;
  flex-direction: column;
  justify-content: flex-start;
  .value-text {
    font-family: 'Hind';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 130%;
  }
`;

const RightSide = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      width: 59%;
    `};
`;

const LinkToHelp = styled.a`
  display: flex;
  align-self: center;
  color: ${select('black')};
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  margin-top: 14px;
`;

const ProgressBarContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: ${({ device }) => (device !== 'mobile' ? 'row' : 'column')};
  justify-content: ${({ device }) => (device === 'tablet' ? 'center' : 'space-between')};
  align-items: center;
  padding-bottom: 8px;

  gap: ${({ device }) => (device !== 'mobile' ? '48' : '1')}px;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      gap: 26px;
    `};
  @media screen and (max-width: 1330px) {
    gap: ${({ device }) => device === 'desktop' && '20px'};
  }
`;

const RatingText = styled.div`
  width: 100%;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: ${({ isBrasilSite, device }) => {
    if (isBrasilSite && device === 'mobile') return '12px';
    if (isBrasilSite && device !== 'mobile') return '13px';
    return '14px';
  }};
  line-height: 22px;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      min-width: 125px;
    `};
`;

const ProgressBarRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ isBrasilSite, device }) => (isBrasilSite && device === 'mobile' ? '1px' : '8px')};
  .containerValue {
    display: flex;
    gap: 3px;
  }
  .value {
    min-width: 20px;
    font-family: 'Hind';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 130%;
    margin-top: 3px;
  }
  ${({ device }) =>
    device === 'tablet' &&
    css`
      width: 270px;
    `};
`;

const MessageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${select('redBack')};
  height: 30px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  position: absolute;
  left: 0px;
  bottom: 0px;
`;

const Alert = styled.div`
  background-image: ${`url(${AlertIcon})`};
  background-size: contain;
  background-repeat: no-repeat;
  width: 15px;
  height: 15px;
  margin-right: 4px;
`;

const Message = styled.div`
  font-size: 12px;
  font-family: 'Hind';
  color: ${select('negative')};
  display: flex;
  > span,
  b {
    margin-left: 3px;
  }
`;

const TotalvalueContainer = styled.div`
  width: 100%;
`;

const TotalValueSpan = styled.div`
  font-family: Hind;
  font-size: ${({ device }) => (device !== 'mobile' ? '16' : '14')}px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  color: ${select('midDarkGrayAux')};
`;

const CommentEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
  height: 297px;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 12%;
  white-space: normal;
  text-align: center;
  margin-top: ${({ device }) => device !== 'mobile' && '40px'};
`;

const MoreComments = styled.button`
  cursor: pointer;
  color: ${select('black')};
  display: flex;
  height: 32px;
  padding: 0px 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-bottom: ${({ device }) => (device === 'desktop' ? '24px' : '0')};
  border-radius: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  white-space: break-spaces;
  ${({ device }) =>
    device !== 'desktop' &&
    css`
      min-width: 54%;
    `};
  :hover {
    background-color: ${({ device }) => (device === 'desktop' ? select('neutralDarkGray') : 'transparent')};
  }
`;

const ChevronDown = styled.img`
  width: 16px;
  margin-bottom: 3px;
`;

const ModalContainer = styled.div`
  width: 588px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: ${select('white')};
  padding: 50px 32px 32px;
`;

const ProgressStyles = {
  high: {
    icon: PositiveIcon,
    barColor: select('accessibleGreen')
  },
  medium: {
    icon: WarmIcon,
    barColor: select('yellow')
  },
  low: {
    icon: NegativeIcon,
    barColor: select('negative')
  },
  noData: {
    icon: NeutralIcon,
    barColor: select('midDarkGray')
  },
  noQuality: {
    icon: NeutralIcon,
    barColor: select('midLightGray')
  }
};

const CommentsContainer = styled.div`
  max-height: ${({ height }) => height || '400px'};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-right: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  /* width */
  ::-webkit-scrollbar {
    width: 11px;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 32px;
    border: 5px solid ${select('white')};
    // border color does not support transparent on scrollbar
    background-color: ${select('middleGray')};
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${select('midLightGray')};
    border-radius: 32px;
  }
`;

const BottomSheetContainer = styled.div`
  padding: 0 4px 20px 20px;
`;

const BottomSheetTitle = styled.div`
  font-family: Hind;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
  text-align: center;
  margin-bottom: 48.88px;
`;

const ContainerQuality = styled.div`
  width: ${({ device }) => (device === 'desktop' ? 'auto' : '100%')};
  display: flex;
  justify-content: center;
  align-items: center;
  .textContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-family: 'Hind';
    font-style: normal;
    .text {
      font-weight: 600;
      font-size: 16px;
      line-height: 130%;
    }
    .qualityText {
      width: 100%;
      font-weight: 700;
      font-size: ${({ qualityStatus }) => (qualityStatus === 'noQuality' ? '24' : '32')}px;
      line-height: 51px;
      text-align: ${({ device }) => (device === 'mobile' ? 'center' : 'start')};
      color: ${({ qualityStatus }) => ProgressStyles[qualityStatus].barColor};
      ${({ device }) =>
        device === 'tablet' &&
        css`
          font-size: 18px;
        `};
    }
  }
`;

const CircleChart = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 60px;
  height: 59px;
  position: relative;
  margin-right: 60px;
  .icon-container {
    background-color: white;
    right: 2px;
    bottom: 4px;
    position: absolute;
    width: fit-content;
    height: fit-content;
    border-radius: 50%;
    padding: 1px;
    .face-icon {
      background-image: ${({ qualityStatus, isFull }) => {
        if (isFull) return `url(${FullIcon})`;
        return qualityStatus && `url(${ProgressStyles[qualityStatus].icon})`;
      }};
      min-width: ${({ isFull }) => (isFull ? 33 : 16)}px;
      min-height: ${({ isFull }) => (isFull ? 26 : 16)}px;
      background-size: cover;
    }
  }
  .single-chart {
    width: 100%;
    justify-content: space-around;
  }
  .circular-chart {
    display: block;
    max-height: 250px;
  }
  .circle-bg {
    fill: none;
    stroke: ${({ qualityStatus }) =>
      qualityStatus === 'noData' || qualityStatus === 'noQuality'
        ? ProgressStyles[qualityStatus].barColor
        : select('midLightGray')};
    stroke-width: 2.8;
  }
  .circle {
    fill: none;
    stroke-width: 2.8;
    stroke-linecap: round;
  }
  .circular-chart.blue .circle {
    stroke: ${({ qualityStatus }) => ProgressStyles[qualityStatus].barColor || select('midLightGray')};
    display: flex;
  }
  .percentage {
    fill: ${({ qualityStatus }) => (qualityStatus ? ProgressStyles[qualityStatus].barColor : select('darkGray'))};
    font-family: 'Hind';
    font-style: normal;
    font-weight: 800;
    font-size: 9px;
    text-anchor: middle;
    display: flex;
  }
  .label {
    fill: ${select('darkGray')};
    font-size: 7px;
    text-anchor: middle;
    font-weight: 400;
    display: flex;
  }
  .label_noQuality {
    fill: ${select('darkGray')};
    font-size: ${({ qualityNotApply }) => (isBrazilPortal && qualityNotApply ? '0.36em' : '0.45em')};
    text-anchor: middle;
    font-weight: 400;
    display: flex;
  }
`;

const TitleContainer = styled.div`
  font-family: 'Hind';
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
`;

const SubTitleContainer = styled.div`
  font-family: 'Hind';
  font-weight: 600;
  font-size: 14px;
  line-height: 26px;
  padding-bottom: 24px;
`;

const BajadaContainer = styled.div`
  font-family: 'Hind';
  font-weight: 400;
  font-size: '16px';
  line-height: 22.41px;
  white-space: pre-line;
  padding-bottom: 8px;
  ${({ device }) =>
    device !== 'desktop' &&
    css`
      margin: 0 16px;
    `};
`;

const MobileBajadaContainerModal = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22.41px;
  padding-top: 8px;
  white-space: pre-line;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const QualityText = styled.div`
  min-width: ${({ device }) => (device !== 'mobile' ? '130px' : '100%')};
  display: flex;
  align-items: center;
  .progressBar-title {
    font-family: 'Hind';
    font-style: normal;
    font-weight: ${({ hoverActive }) => (hoverActive ? '600' : '400')};
    font-size: 14px;
    line-height: 22px;
  }
  .image-faces {
    margin: 0 0 1px 8px;
  }
  ${({ device }) =>
    device === 'tablet' &&
    css`
      min-width: 125px;
    `};
`;

const QualityContainer = styled.div`
  width: 505px;
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-bottom: 24px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  padding-bottom: 24px;
`;

const InfoLevel = styled.div`
  display: flex;
  flex-direction: row;
  font-size: ${({ background }) => (background === '' ? '24px' : '12px')};
  align-items: center;
  font-weight: 400;
  background: ${({ background }) => (!background ? '' : background)};
  border-radius: 8px;
  padding: 0px 8px 0px 8px;
  height: 20px;
  width: 70px;
  color: ${({ color }) => (!color ? '' : color)};
`;

const Icon = styled.div`
  width: 16px;
  height: 16px;
  background-image: ${({ icon }) => `url(${icon})`};
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 8px;
  @media screen and (max-width: 360px) {
    margin-right: 4px;
  }
`;

const Secondary = styled.button`
  display: flex;
  width: 184px;
  height: 32px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  color: ${({ disabled }) => (disabled === true ? '#C8C8C8' : '')};
  border: ${({ disabled }) => (disabled === true ? '1px solid #C8C8C8' : '1px solid #ff5500')};
  font-weight: 600;

  cursor: pointer;
  :disabled {
    cursor: not-allowed;
  }
`;

const HeaderSectionContainer = styled.div`
  justify-content: center;
  align-items: center;
  gap: 16px;
  display: ${({ device }) => (device === 'desktop' ? 'inline-flex' : 'inline-flex')};
  align-items: center;
`;

const MobileBajadaContainer = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22.41px;
  padding-top: 8px;
  white-space: pre-line;
  padding-bottom: 8px;
`;

const ContainerValueMobile = styled.div`
  font-family: 'Hind';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 106%;
  padding-top: 8px;
`;

const Parrafo = styled.p`
  width: 95%;
`;

const SpanText = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

const LinkToDownloadPostingsQuality = styled.a`
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-decoration: underline;
  border-radius: 8px;
  color: ${({ downloaded }) => downloaded && select('midDarkGray')};
  cursor: ${({ downloaded }) => (downloaded ? 'not-allowed' : 'pointer')};
  pointer-events: ${({ downloaded }) => downloaded && 'none'};
  white-space: break-spaces;
  :hover {
    background-color: ${select('middleGray')};
  }
`;

export {
  Container,
  HeaderArea,
  Icon,
  TitleText,
  TooltipComponent,
  IconTooltip,
  IconInfo,
  ContainerInfo,
  MainArea,
  LeftSide,
  ContainerRaitings,
  ContainerValue,
  Rating,
  RightSide,
  ProgressBarContainer,
  RatingText,
  ProgressBarRow,
  MessageContainer,
  Alert,
  Message,
  TotalvalueContainer,
  TotalValueSpan,
  LinkToHelp,
  MoreComments,
  ChevronDown,
  ModalContainer,
  CommentsContainer,
  BottomSheetContainer,
  BottomSheetTitle,
  CommentEmptyState,
  ContainerQuality,
  CircleChart,
  TitleContainer,
  BajadaContainer,
  SubTitleContainer,
  ContainerModalBody,
  QualityText,
  QualityContainer,
  ButtonContainer,
  InfoLevel,
  Secondary,
  HeaderSectionContainer,
  MobileBajadaContainer,
  ContainerValueMobile,
  Parrafo,
  SpanText,
  LinkToDownloadPostingsQuality,
  MobileBajadaContainerModal
};
